import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, ComboBox, RadioGroup } from '@reveni-io/reveni-ui'

import DelayDaysInput from '@/common/components/DelayDaysInput/DelayDaysInput'
import ReasonField from '@/common/components/ReasonField/ReasonField'
import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import { triggerModeValues } from '../constants'
import { getTriggerModeOptions, getTriggerOptions } from '../helpers'
import { refundTriggerModeOptions, refundTriggerOptions } from './constants'
import * as Styles from './styles'

const ForceRefundTriggerConfig = ({ config, onChangeConfig, disabled, errors = [], availableIssueRefundStatuses }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasTriggerError = errors.some(e => e.type === errorTypes.actionRefundTriggerEmpty)
  const hasDelayDaysError = errors.some(e => e.type === errorTypes.actionDelayDaysInvalid)

  const triggerOptions = getTriggerOptions(refundTriggerOptions, t, availableIssueRefundStatuses)
  const modeOptions = getTriggerModeOptions(refundTriggerModeOptions, t)
  const isDelayMode = config.refund_trigger_mode === triggerModeValues.delayByDays

  const handleChangeTrigger = e => onChangeConfig({ refund_trigger_status: e.target.value })

  const handleChangeMode = e => {
    const mode = e.target.value

    if (mode === triggerModeValues.delayByDays) {
      onChangeConfig({
        refund_trigger_mode: mode,
        refund_trigger_delay_days: config.refund_trigger_delay_days || '',
        refund_trigger_delay_reason: config.refund_trigger_delay_reason || '',
      })
    } else {
      onChangeConfig({
        refund_trigger_mode: mode,
        refund_trigger_delay_days: null,
        refund_trigger_delay_reason: '',
      })
    }
  }

  const handleChangeDelayDays = e => onChangeConfig({ refund_trigger_delay_days: e.target.value })

  const handleChangeDelayReason = e => onChangeConfig({ refund_trigger_delay_reason: e.target.value })

  return (
    <Styles.Container>
      <Alert type="warning">{t('Esta acción no aplica a los reembolsos instantáneos.')}</Alert>
      <ComboBox
        label={t('Trigger')}
        menuItems={triggerOptions}
        handleChange={handleChangeTrigger}
        value={config.refund_trigger_status || ''}
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasTriggerError}
        helperText={hasTriggerError ? t('Este campo es obligatorio') : ' '}
      />
      <RadioGroup
        name="refund-trigger-mode"
        options={modeOptions}
        value={config.refund_trigger_mode}
        onChange={handleChangeMode}
      />
      {isDelayMode && (
        <>
          <DelayDaysInput
            value={config.refund_trigger_delay_days}
            onChange={handleChangeDelayDays}
            disabled={disabled}
            error={hasDelayDaysError}
          />
          <ReasonField
            value={config.refund_trigger_delay_reason}
            onChange={handleChangeDelayReason}
            disabled={disabled}
            placeholder={t('Explicación del motivo')}
          />
        </>
      )}
    </Styles.Container>
  )
}

export default ForceRefundTriggerConfig
